import type { SearchType } from '@/api/search';

import { labelOf } from './humanize';

export type { SearchType };

/** The heading over each kind of record a search finds. */
export const SEARCH_TYPE_LABELS: Record<SearchType, string> = {
  CUSTOMER: 'Customers',
  JOB: 'Jobs',
  DEAL: 'Deals',
  LEAD: 'Leads',
  PROPOSAL: 'Proposals',
  INVOICE: 'Invoices',
  MATERIAL: 'Materials',
  SERVICE: 'Services',
  PERSON: 'People',
};

/** What one record of each kind is called, for the words that name a single hit. */
export const SEARCH_TYPE_NOUNS: Record<SearchType, string> = {
  CUSTOMER: 'customer',
  JOB: 'job',
  DEAL: 'deal',
  LEAD: 'lead',
  PROPOSAL: 'proposal',
  INVOICE: 'invoice',
  MATERIAL: 'material',
  SERVICE: 'service',
  PERSON: 'person',
};

export function searchTypeLabel(type: string | null | undefined): string {
  return labelOf(SEARCH_TYPE_LABELS, type);
}

export function searchTypeNoun(type: string | null | undefined): string {
  return labelOf(SEARCH_TYPE_NOUNS, type);
}
